<template>
  <div>
    <el-dialog
      custom-class="loading-box"
      :visible="centerDialogVisible"
      width="600px"
      center
      :show-close="false"
    >
      <div class="loading-icon">
        <img src="@/assets/images/deleteDialog.png" />
        <div
          style="white-space: pre-wrap;"
          class="loading-text"
          v-html="titleCh"
        ></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="info"
          @click.native="onConfirmButton"
          class="button-el-el"
          >確定</el-button
        >
        <el-button
          type="success"
          class="button-el-el"
          @click.native="onCancelButton"
          >取消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    titleCh: {
      type: String,
      default: "",
    },
    titleEn: {
      type: String,
      default: "",
    },
    centerDialogVisible: {
      type: Boolean,
      default: false,
    },
    isICon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCancelButton() {
      this.$emit("onCancelButton");
    },
    onConfirmButton() {
      this.$emit("confirmFunction");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .loading-box {
    border-radius: 10px;
  }
}
.loading-icon {
  font-size: 55px;
  text-align: center;
}
.loading-text {
  font-size: 20px;
  white-space: pre-wrap;
}
</style>
